module.exports = __webpack_public_path__ + "aeda9b2580e4ea3eb04ca56bf3bb7f80.svg";